import { FC, useContext, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { DashboardTableReturnedBatch } from './DashboardTableReturnedBatch';
import { useTranslation } from 'react-i18next';
import { DashboardTableTimerCancelButton } from '../actions/DashboardTableTimerCancelButton';
import { DashboardTableSiteSelect } from '../DashboardTableSiteSelect';
import { DashboardTableLabel } from '../actions/DashboardTableLabel';
import { DashboardTableActionsDeleteButton } from '../actions/DashboardTableActionsDeleteButton';
import { DashboardTableActions } from '../DashboardTableActions';
import { DashboardContext } from '../../DashboardContext';
import { Site } from '../../../sites/dto/Site';

export const DashboardTableReturnedBatchActions: FC<{
  batch: DashboardTableReturnedBatch;
}> = observer(({ batch }) => {
  const { t } = useTranslation();
  const { data: sites = [] } = useContext(DashboardContext).sites;
  const [selectedSite, setSelectedSite] = useState<Site | null>(null);

  // Pre-select site from pending transaction if all assets have the same site
  useEffect(() => {
    const commonSiteId = batch.commonPendingTransactionSiteId;
    if (commonSiteId && !selectedSite) {
      const site = sites.find((s) => s.id === commonSiteId);
      if (site) {
        setSelectedSite(site);
      }
    }
  }, [batch.commonPendingTransactionSiteId, sites, selectedSite]);

  return (
    <DashboardTableActions>
      {batch.batchRequestInProgress ? (
        <DashboardTableLabel>{t('Loading')}</DashboardTableLabel>
      ) : batch.cancelCountdown ? (
        <DashboardTableTimerCancelButton
          countdown={batch.cancelCountdown}
          onClick={() => {
            batch.stopCancelCountdown();
          }}
        />
      ) : batch.canBeProcessedAssets.length ? (
        <DashboardTableSiteSelect
          placeholder={t('Return to site')}
          selectedSiteId={selectedSite?.id}
          onSiteSelect={async (site) => {
            setSelectedSite(site);
            await batch.approveBatch(site);
          }}
        />
      ) : null}

      <DashboardTableActionsDeleteButton
        onDelete={async () => {
          await batch.delete();
        }}
      >
        {t('Cancel')}
      </DashboardTableActionsDeleteButton>
    </DashboardTableActions>
  );
});
